import axios from "axios";
import axiosInterceptor from './AxiosInterceptor';
import ConcurrentSession from '../components/concurrent-session/ConcurrentSessionModal'
import { makeSecureAPICall , generateSignature } from "./SignatureHelperFn";

export const baseUrl = process.env.REACT_APP_BASE_API_URL;
export const idmUrl = process.env.REACT_APP_IDM_URL;
const appBaseUrl = process.env.REACT_APP_BASE_URL;

axiosInterceptor();

export const apiWithoutInterceptor = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL,
  withCredentials: true,
});

//Login API
export const getUserInfo = async () => {
 const new_session_request= JSON.parse(sessionStorage.getItem("new_session_request")) || false
  let payload = {
    user_id: "",
    password: "",
    new_session_request,
  };
  try {
    const { data } = await axios.post(`${baseUrl}/login`, payload, {
      withCredentials: true,
    });
    sessionStorage.setItem("new_session_request",JSON.stringify(false));
    localStorage.setItem("accessDeniedError",false);
    return data;
  } catch (error) {
    if (error.response.status === 403) {
      window.location.replace(`${appBaseUrl}/exit.html?idmUrl=${idmUrl}`)
      localStorage.setItem("accessDeniedError",true);

    } else {
      window.location.replace(idmUrl);
      // console.log('Error', error.message);
    }
    // console.log(error.config);
    return ;
  }
};

//to get list of analysis for landing screen
// Analysis Library API
export const getAnalysisLibrary = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/analysis-library`, payload);
};

// Logout API
export const logout = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/logout`, payload);
};

// Display Filter Data API
export const getDisplayFilterData = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/display-user-filter-data`, payload);
};

// Get Users Email API
export const getUsersEmail = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/get-users-email`, payload);
};

// Share Analysis to User API
export const ShareAnalysisToUser = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/share-analysis`, payload);
};

// Filter Dropdown Data API
export const getFilterDropdownDataAPI = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/filter-dropdown-data`, payload);
};

// Save Filter Data API
export const saveFilterDataAPI = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/save-user-filter-data`, payload);
};

// Get Analysis Data API (Note: This one returns both data and headers)
export const getAnalysisData = async (payload) => {
  try {
    const signature = await generateSignature(payload, "PEB_5qKx$Y8zN3W@rV!6dLp#Tz!X$g^a7Mw2Bk%HjR^s*3vBz");
    
    const { data, headers } = await axios.post(
      `${baseUrl}/display-analysis-screen`,
      payload,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'X-Signature': signature
        }
      }
    );
    
    return { data, headers };
  } catch (error) {
    if (error.response?.status === 401 || error.response?.status === 403) {
      window.location.replace(idmUrl);
    }
    throw error;
  }
};

// Findings Report Settings API
export const getFindingsReportSettings = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/display-analysis-settings`, payload);
};

// Findings Settings Dropdown Data API
export const getFindingsSettingsDropdownData = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/finding-settings-dropdown`, payload);
};

// Create Findings Report API
export const createFindingsReport = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/save-created-analysis`, payload);
};

// Save Findings Report Data API
export const saveFindingsReportData = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/save-findings-data`, payload);
};

// Delete Created Analysis API
export const deleteCreatedAnalysis = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/delete-created-analysis`, payload);
};

// Copy Analysis API
export const copyAnalysis = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/copy-created-analysis`, payload);
};

// Download Screenshots API
export const downloadScreenshots = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/download-findings-report`, payload);
};

// Delete Findings Data API
export const deleteFindingsData = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/delete-findings-data`, payload);
};

// Check Report Name Unique API
export const isReportNameUnique = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/get-all-analysis`, payload);
};

// Get More Insights API
export const getMoreInsightsApi = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/get-more-insights`, payload);
};

export const addUserApi = async (payload) => {
  try {
    return await makeSecureAPICall(`${baseUrl}/add-user`, payload);
  } catch (error) {
    return { status: "FAILED", message: "User already exists or something went wrong. Please try again." };
  }
};

// Refresh Existing Report API
export const refreshExistingReport = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/refresh-analysis-data`, payload);
};

// Check Card Limit API
export const checkCardLimit = async (payload) => {
  return await makeSecureAPICall(`${baseUrl}/check-card-limit`, payload);
};